'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t from "../defs/DotsThreeVertical.js";
var s = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var a = (r, e, t2) => e in r ? s(r, e, { enumerable: true, configurable: true, writable: true, value: t2 }) : r[e] = t2, m = (r, e) => {
  for (var t2 in e || (e = {}))
    p.call(e, t2) && a(r, t2, e[t2]);
  if (o)
    for (var t2 of o(e))
      l.call(e, t2) && a(r, t2, e[t2]);
  return r;
}, i = (r, e) => c(r, f(e));
const D = forwardRef((r, e) => /* @__PURE__ */ a__default.createElement(b, i(m({ ref: e }, r), { weights: t })));
D.displayName = "DotsThreeVertical";
export {
  D as DotsThreeVertical
};
